const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductMediaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  moveToIdx (index, type = null) {
    if (!this.carousel || typeof index !== 'number') return

    let targetIndex = index

    if (type === 'image') {
      const slides = this.els.slide.elements

      const matchedIndex = slides.findIndex((slide) => {
        return parseInt(slide.dataset.imageIndex, 10) === index
      })

      if (matchedIndex === -1) return

      targetIndex = matchedIndex
    }

    this.carousel.moveToIdx(targetIndex)
  }
}

if (!customElements.get('product-media-carousel')) {
  customElements.define('product-media-carousel', ProductMediaCarousel)
}
